export default [
  {
    value: 'organizerName',
    text: 'Название',
    type: 'string',
    description: ''
  },
  {
    value: 'slug',
    text: 'Уникальное имя для URL',
    width: 190,
    type: 'string',
    description: ''
  },
  {
    value: 'copySlug',
    text: 'Скопировать',
    width: 80,
    align: 'end',
    type: 'actions',
    sortable: false,
    description: ''
  },
  {
    value: 'translations',
    text: 'Языки',
    width: 160,
    type: 'string',
    sortable: false,
    description: ''
  },
  {
    value: 'status',
    text: 'Статус',
    width: 180,
    type: 'text',
    description: ''
  },
  {
    value: 'createdAt',
    text: 'Создано',
    width: 180,
    type: 'date',
    description: ''
  },
  {
    value: 'updatedAt',
    text: 'Обновлено',
    width: 180,
    type: 'date',
    description: ''
  },
  {
    text: 'Сортировка',
    value: 'sortOrder',
    width: 120,
    type: 'string',
    description: ''
  },
  {
    value: 'events',
    text: 'Кол-во событий',
    width: 140,
    type: 'array',
    description: ''
  },
  {
    value: 'actions',
    text: 'Действия',
    width: 105,
    align: 'end',
    type: 'actions',
    sortable: false,
    description: ''
  }
]
